
const nullState = {
  ownerName: null,
  project: null,
  phoneNumber: null,
  groups: [],
  hasChanges: false,
}

export default {
  namespaced: true,
  state: () => ({ ...nullState }),
  mutations: {

    // reset state
    reset (state) {
      Object.keys(nullState).forEach(k => state[k] = nullState[k])
    },

    // replace the entire state from a device
    setDevice (state, device) {
      Object.keys(device).forEach(k => state[k] = device[k])
      state.hasChanges = false
    },

    // needed for <vuex-input .../>
    setOwnerName (state, ownerName) { state.ownerName = ownerName; state.hasChanges = true },
    setProject (state, project) { state.project = project; state.hasChanges = true },
    setPhoneNumber (state, phoneNumber) { state.phoneNumber = phoneNumber; state.hasChanges = true },
    setGroups (state, groups) { state.groups = groups || []; state.hasChanges = true },
  },
}